<template>
  <div></div>
</template>
<script>
import actions from "@/config/actions";
import { mapActions, mapMutations } from "vuex";
import ApiService from '@/service/apiService';
import Api from '@/config/api';

export default {
  name: "Logout",
  mounted() {
    this.signOut();
  },
  methods: {
    ...mapActions([actions.auth.LOGOUT]),
    ...mapMutations({ clear: "clearAll" }),
    ...mapMutations({ clearTemplate: "clearTemplate" }),
    signOut() {

  return ApiService.post(Api.endpoints.LOGOUT, {})
                  .then(() => {
                    this.clear();
                    this.clearTemplate();
                    this[actions.auth.LOGOUT]();
                    this.$router.push("/");
              })
              .catch(({ response }) => this.parseErrorResponse(response))
              .then(() => {
                  this.loading = false;
              });
    }
  }
};
</script>
